<template>
  <div v-if="visible" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" style="margin-top:0px;">
    <div class="bg-white p-6 rounded-lg shadow-lg" style="width: 1000px;">
      <!-- Header slot -->
      <div class="mb-4">
        <slot name="header"></slot>
      </div>

      <!-- Content slot -->
      <div class="mb-4">
        <slot></slot>
      </div>

      <!-- Footer slot -->
      <div class="mt-4 text-right">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    visible: Boolean
  }
}
</script>
